<ng-container *ngIf="data.pragmaticTaskStatusCode && data.pragmaticTaskStatusCode >= 3">
    <div class="align-content-center">
        <ejs-tooltip id='tooltip' content="{{data.pragmaticValidationDate | date:  formatOptions.format}}">
            <div class="d-flex flex-row justify-content-between align-content-center" *ngIf="data.pragmaticValidationStatusCode !== 3">
                <span>
                    <i [ngClass]="{'fa-solid': true,
                        'fa-check icon-success': data.pragmaticValidationStatusCode === 1,
                        'fa-xmark icon-danger': data.pragmaticValidationStatusCode === 2}"
                        >
                    </i>
                    <span class="mx-2"> Validation  {{data.pragmaticValidationStatus == 'Fail' ? 'Failed' : 'Passed'}}</span>
                    
                </span>
                <a  class='pointer underline' 
                (click)="downloadFile(data.pragmaticResponseFilePath, data.pragmaticResponseFileName)"
                >
                    <i class="fas fa-download mx-2" aria-hidden="true"></i> <span class="download-align">Results</span>
                </a>
            </div>
        </ejs-tooltip>
      <span *ngIf="data.pragmaticValidationStatusCode === 3"><i class="fa-solid fa-triangle-exclamation icon-warning"></i> Timeout, please retry</span>

    </div>
</ng-container>
<span *ngIf="data.pragmaticTaskStatusCode === 1 || data.pragmaticTaskStatusCode === 2" class="in-progress">In process...</span>
